import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ToolsContainer = styled.div`
  padding: var(--spacing-xxl) 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
`;

const PageTitle = styled.h1`
  text-align: center;
  margin-bottom: var(--spacing-md);
  
  span {
    color: var(--accent-blue);
  }
`;

const IntroText = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto var(--spacing-xl);
  font-size: 1.2rem;
  color: var(--text-light);
`;

const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-xl);
  margin-top: var(--spacing-xl);
  margin-bottom: var(--spacing-xxl);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ToolCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const ToolIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-md);
  font-size: 1.8rem;
  background-color: ${props => {
    switch(props.tool) {
      case 'atraversa':
        return 'rgba(123, 211, 244, 0.1)';
      case 'itinerary': 
        return 'rgba(62, 221, 226, 0.1)';
      case 'fam-trip': 
        return 'rgba(123, 123, 243, 0.1)';
      case 'marketing': 
        return 'rgba(123, 211, 244, 0.1)';
      default: 
        return 'rgba(62, 221, 226, 0.1)';
    }
  }};
  color: ${props => {
    switch(props.tool) {
      case 'atraversa':
        return 'var(--accent-blue)';
      case 'itinerary': 
        return 'var(--accent-turquoise)';
      case 'fam-trip': 
        return 'var(--accent-lavender)';
      case 'marketing': 
        return 'var(--accent-blue)';
      default: 
        return 'var(--accent-turquoise)';
    }
  }};
`;

const ToolContent = styled.div`
  padding: var(--spacing-lg);
`;

const ToolTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: var(--spacing-sm);
  color: var(--text);
`;

const ToolDescription = styled.p`
  color: var(--text-light);
  margin-bottom: var(--spacing-md);
  min-height: 4.5rem;
`;

const ToolButton = styled(Link)`
  display: inline-block;
  background-color: ${props => {
    switch(props.tool) {
      case 'itinerary': 
        return 'var(--accent-turquoise)';
      case 'fam-trip': 
        return 'var(--accent-lavender)';
      case 'marketing': 
        return 'var(--accent-blue)';
      default: 
        return 'var(--accent-turquoise)';
    }
  }};
  color: white;
  padding: 0.6rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid ${props => {
    switch(props.tool) {
      case 'itinerary': 
        return 'var(--accent-turquoise)';
      case 'fam-trip': 
        return 'var(--accent-lavender)';
      case 'marketing': 
        return 'var(--accent-blue)';
      default: 
        return 'var(--accent-turquoise)';
    }
  }};
  transition: all 0.3s ease;
  
  &:hover {
    background-color: transparent;
    color: var(--text);
  }
`;

const ExternalLink = styled.a`
  display: inline-block;
  background-color: ${props => {
    switch(props.tool) {
      case 'atraversa': 
        return 'var(--accent-blue)';
      case 'itinerary': 
        return 'var(--accent-turquoise)';
      case 'fam-trip': 
        return 'var(--accent-lavender)';
      case 'marketing': 
        return 'var(--accent-blue)';
      default: 
        return 'var(--accent-turquoise)';
    }
  }};
  color: white;
  padding: 0.6rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid ${props => {
    switch(props.tool) {
      case 'atraversa': 
        return 'var(--accent-blue)';
      case 'itinerary': 
        return 'var(--accent-turquoise)';
      case 'fam-trip': 
        return 'var(--accent-lavender)';
      case 'marketing': 
        return 'var(--accent-blue)';
      default: 
        return 'var(--accent-turquoise)';
    }
  }};
  transition: all 0.3s ease;
  
  &:hover {
    background-color: transparent;
    color: var(--text);
  }
`;

const DemoSection = styled.div`
  background-color: var(--secondary);
  border-radius: 8px;
  padding: var(--spacing-xl);
  margin-bottom: var(--spacing-xxl);
`;

const DemoTitle = styled.h2`
  text-align: center;
  margin-bottom: var(--spacing-lg);
`;

const DemoContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: var(--spacing-lg);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const FormGroup = styled.div`
  margin-bottom: var(--spacing-md);
`;

const Label = styled.label`
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: 600;
  color: var(--text);
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--grey-border);
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-color: var(--accent-turquoise);
    outline: none;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--grey-border);
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  
  &:focus {
    border-color: var(--accent-turquoise);
    outline: none;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--grey-border);
  border-radius: 4px;
  font-size: 1rem;
  min-height: 120px;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-color: var(--accent-turquoise);
    outline: none;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Button = styled.button`
  background-color: var(--accent-turquoise);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid var(--accent-turquoise);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: transparent;
    color: var(--text);
  }
`;

const ResultBox = styled.div`
  margin-top: var(--spacing-lg);
  padding: var(--spacing-md);
  border: 1px solid var(--grey-border);
  border-radius: 4px;
  background-color: rgba(62, 221, 226, 0.05);
`;

const ComingSoon = styled.div`
  background-color: rgba(123, 123, 243, 0.1);
  border-radius: 8px;
  padding: var(--spacing-lg);
  text-align: center;
  margin-top: var(--spacing-md);
`;

const ComingSoonTag = styled.span`
  display: inline-block;
  background-color: var(--accent-lavender);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: var(--spacing-md);
`;

const CTASection = styled.div`
  background-color: var(--secondary);
  padding: var(--spacing-xl);
  border-radius: 8px;
  text-align: center;
  margin-top: var(--spacing-xl);
`;

const CTATitle = styled.h2`
  margin-bottom: var(--spacing-md);
`;

const CTADescription = styled.p`
  max-width: 800px;
  margin: 0 auto var(--spacing-lg);
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background-color: var(--accent-turquoise);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid var(--accent-turquoise);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: transparent;
    color: var(--text);
  }
`;

// Sample tool data
const toolsData = [
  {
    id: 'atraversa',
    title: 'atraversa',
    description: 'AI-powered platform connecting travel suppliers with specialized travel agents, eliminating expensive trade shows.',
    icon: '🧭',
    status: 'available',
    externalLink: 'https://www.atraversa.com'
  },
  {
    id: 'travel-brand',
    title: 'Travel Brand Generator',
    description: 'Discover your travel brand\'s archetype with our interactive quiz to define your unique voice and attract the right audience.',
    icon: '🏷️',
    status: 'available',
    externalLink: '/tools/travel-brand-generator'
  },
  {
    id: 'sentiment-analyzer',
    title: 'Tourism Sentiment Analyzer',
    description: 'Analyze reviews and feedback with tourism-specific sentiment analysis to uncover actionable insights.',
    icon: '📊',
    status: 'available',
    externalLink: '/tools/tourism-sentiment-analyzer'
  },
  {
    id: 'itinerary',
    title: 'Multiday Itinerary Generator',
    description: 'Turn ideas into trips in minutes with our automated itinerary builder.',
    icon: '✈️',
    status: 'available',
    externalLink: 'https://shareitinerary.com'
  },
  {
    id: 'fam-trip',
    title: 'Plan Fam Trips',
    description: 'Design and pitch trips that sell to travel agents and tour operators.',
    icon: '🌎',
    status: 'available',
    externalLink: 'https://planfamtrips.com'
  },
  {
    id: 'marketing',
    title: 'Marketing Plan Generator',
    description: 'Create comprehensive marketing strategies for tour operators and destinations, from content planning to campaign execution.',
    icon: '📊',
    status: 'available',
    externalLink: 'https://travelmarketingplan.com'
  }
];

const Tools = () => {
  return (
    <ToolsContainer>
      <Container>
        <PageTitle>Our <span>Tools</span></PageTitle>
        <IntroText>We create digital solutions specifically designed for small to medium travel operators, making technology accessible and practical for businesses focused on authentic travel experiences.</IntroText>
        
        <ToolsGrid>
          {toolsData.map((tool) => (
            <ToolCard key={tool.id}>
              <ToolContent>
                <ToolIcon tool={tool.id}>{tool.icon}</ToolIcon>
                <ToolTitle>{tool.title}</ToolTitle>
                <ToolDescription>{tool.description}</ToolDescription>
                
                {tool.status === 'available' ? (
                  <ExternalLink 
                    tool={tool.id}
                    href={tool.externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Tool
                  </ExternalLink>
                ) : (
                  <ComingSoon>
                    <ComingSoonTag>Coming Soon</ComingSoonTag>
                    <p>This tool is currently in development.</p>
                  </ComingSoon>
                )}
              </ToolContent>
            </ToolCard>
          ))}
        </ToolsGrid>
        
        <CTASection>
          <CTATitle>Need a Custom Tool?</CTATitle>
          <CTADescription>
            We can build bespoke tools that integrate with your existing systems and workflows.
            Our development team specializes in creating intuitive, user-friendly interfaces that enhance
            the travel planning and management experience.
          </CTADescription>
          <CTAButton to="/contact">Discuss Your Requirements</CTAButton>
        </CTASection>
      </Container>
    </ToolsContainer>
  );
};

export default Tools;